export default __webpack_public_path__ + "static/media/snow.c8ed556c.png";